import React from 'react';
import axios from './../../../constants/axios';
import { Link } from 'react-router';
import moment from 'moment';
import ReactPaginate from 'react-paginate';

class ProductHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         products: [],
         page: 1,
         pageCount: 10,
      };
   }

   componentDidMount() {
      this.loadProduct(this.state.page);
   }

   loadProduct = (page) => {
      axios.get('items/getAllProducts', {
         params: {
            page: page,
         }
      })
         .then((res) => {
            this.setState({
               products: res.data.items,
               pageCount: res.data.pageCount,
            });
         });
   };

   handlePageClick = (data) => {
      const page = data.selected + 1;
      this.setState({ page: page, products: [] });
      this.loadProduct(page);
   };

   render() {
      const mainRowStyle = {
         marginBottom: '10px',
         borderTop: '1px solid black',
         borderBottom: '1px solid black'
      };
      const subRowStyle = Object.assign({}, mainRowStyle, {
         marginLeft: '15px'
      });

      return (
         <div className="ProductHome" >
            <div>
               <h3>Products</h3>
               <ReactPaginate previousLabel={"previous"}
                              nextLabel={"next"}
                              breakLabel={<a href="" >...</a>}
                              breakClassName={"break-me"}
                              pageCount={this.state.pageCount}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={this.handlePageClick}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
            </div>
            <hr/>
            <div className="__products" >
               <div className="row" >
                  <h4 className="col-md-1" >Id</h4>
                  <h4 className="col-md-5" >Name</h4>
                  <h4 className="col-md-1" >Price</h4>
                  <h4 className="col-md-1" >Discount</h4>
                  <h4 className="col-md-1" >Status</h4 >
                  <h4 className="col-md-2" >Price Update</h4>
                  <h4 className="col-md-1" >Actions</h4 >
               </div>
               {this.state.products.map((product) => (
                  <div key={product.id} className="top_row" >
                     <div className="row product_row" style={mainRowStyle} >
                        <div className="col-md-1" >{product.id}</div>
                        <div className="col-md-5" >{product.name}</div>
                        <div className="col-md-1" >{product.price}</div>
                        <div className="col-md-1" >{product.discount}</div>
                        <div className="col-md-1" >{product.active}</div >
                        <div className="col-md-2" >{moment(product.price_update_at).fromNow()}</div>
                        <div className="col-md-1" >
                           {" | "}
                           <Link to={`/product/productMain/${product.id}`} >details</Link>
                           {" | "}
                           <Link to={`/product/productMain/edit/${product.id}`} >edit</Link>
                           {" | "}
                        </div>
                     </div>
                     {
                        product.subProducts ?
                           product.subProducts.map((s) => (
                              <div key={s.id} className="row" style={subRowStyle} >
                                 <div className="col-md-1" >{s.id}</div>
                                 <div className="col-md-9" >{s.name}</div>
                                 <div className="col-md-2" >
                                    {" | "}
                                    <Link to={`/product/productSub/${s.id}`} >details</Link>
                                    {" | "}
                                    <Link to={`/product/productSub/edit/${s.id}`} >edit</Link>
                                    {" | "}
                                 </div>
                              </div>
                           ))
                           : null
                     }
                  </div>
               ))}
            </div>
         </div>
      );
   }
}

export default ProductHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductHome.js
 **/